import { Button } from '@/components/shadcn/button'
import { CollapsibleFilterContainer } from '@/components/ui/CollapsibleFilterContainer'
import { useMemo, useState } from 'react'
import { SearchInput } from '../../component-library/shared/SearchInput'
import { DataAssetsAccordion } from './DataAssetsAccordian'
import { DataAssetsFilter } from './DataAssetsFilter'
import { useGetDataAssets } from './useGetDataAssets'
import { filterDataAssets, groupDataAssets } from './utils'
import { IconV2RotateClockwiseOutline } from '@icons/IconV2RotateClockwiseOutline'

export function DataAssetsV2() {
  const { data: summary, refetch } = useGetDataAssets({})
  const [filter, setFilter] = useState<string>('All')
  const [search, setSearch] = useState<string>('')
  const filteredSummary = useMemo(() => filterDataAssets(summary, filter, search), [filter, search, summary])
  const groupedAndFilteredSummary = useMemo(() => groupDataAssets(filteredSummary), [filteredSummary])

  return (
    <>
      <div className="sticky top-0 flex w-full items-center justify-between bg-background/50 py-2 backdrop-blur">
        <SearchInput value={search} onChange={setSearch} />
        <div className="flex items-center gap-x-2">
          <CollapsibleFilterContainer>
            <DataAssetsFilter filter={filter} setFilter={setFilter} />
          </CollapsibleFilterContainer>
          <Button variant="ghost" size="icon" onClick={() => refetch()}>
            <IconV2RotateClockwiseOutline size={20} />
          </Button>
        </div>
      </div>
      {groupedAndFilteredSummary.items.length === 0 ? (
        <div className="px-2 py-8 text-center text-sm text-muted-foreground">No data assets for this workspace.</div>
      ) : (
        <DataAssetsAccordion summary={groupedAndFilteredSummary} />
      )}
    </>
  )
}
